import {
  ACTIVITIES,
  OFFICES,
  JURISDICTIONS,
  VISA_COST,
  SHAREHOLDER_COST,
} from "@/app/calculator/constants/calculatorData";

/**
 * Format number as AED currency
 * @param {number} n
 * @returns {string}
 */
export function formatAED(n) {
  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED",
    minimumFractionDigits: 0,
  }).format(n);
}

/**
 * Calculate total cost from form data
 * @param {import("../constants/types").FormData} data
 * @returns {number}
 */
export function calcTotal(data) {
  const activity    = ACTIVITIES.find((a) => a.id === data.activity);
  const office      = OFFICES.find((o) => o.id === data.office);
  const jurisdiction = JURISDICTIONS.find((j) => j.id === data.jurisdiction);

  return (
    (jurisdiction?.base    ?? 12500) +
    (activity?.baseCost    ?? 0)     +
    (office?.price         ?? 2000)  +
    data.visas        * VISA_COST    +
    data.shareholders * SHAREHOLDER_COST
  );
}

/**
 * Build line items array for the summary step
 * @param {import("../constants/types").FormData} data
 * @returns {{ label: string, amount: number }[]}
 */
export function buildLineItems(data) {
  const activity    = ACTIVITIES.find((a) => a.id === data.activity);
  const office      = OFFICES.find((o) => o.id === data.office);
  const jurisdiction = JURISDICTIONS.find((j) => j.id === data.jurisdiction);

  return [
    { label: `${jurisdiction?.label ?? "Free Zone"} licence`,               amount: jurisdiction?.base   ?? 12500 },
    { label: `Activity — ${activity?.label ?? "—"}`,                        amount: activity?.baseCost   ?? 0     },
    { label: `Office — ${office?.label ?? "—"}`,                            amount: office?.price        ?? 0     },
    { label: `Visas (${data.visas} × AED ${VISA_COST.toLocaleString()})`,   amount: data.visas * VISA_COST        },
    { label: `Shareholders (${data.shareholders} × AED ${SHAREHOLDER_COST.toLocaleString()})`, amount: data.shareholders * SHAREHOLDER_COST },
  ];
}

/**
 * Check if current step can proceed to next
 * @param {number} step
 * @param {import("../constants/types").FormData} data
 * @returns {boolean}
 */
export function canProceed(step, data) {
  switch (step) {
    case 1: return !!data.activity;
    case 2: return !!data.reason;
    case 3: return !!data.office;
    case 4: return !!data.jurisdiction && !!data.inUAE && !!data.timeline;
    default: return true;
  }
}
